import { render, staticRenderFns } from "./footer-atis.vue?vue&type=template&id=d2769fe8&"
import script from "./footer-atis.vue?vue&type=script&lang=js&"
export * from "./footer-atis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports